import { IEafReason } from 'modules/employeeActionsForm/store/models';
import { IStore } from 'store/configureStore';

export const selectEmployeeActionFormState = (state: IStore) =>
    state.modules.employeeActonForm;

export const selectEafAssignmentsFilter = (state: IStore) => selectEmployeeActionFormState(state).assignmentFilter;
export const selectEafReasons = (state: IStore): IEafReason[] => selectEmployeeActionFormState(state).reasons;
export const selectIsEafCreating = (state: IStore) => selectEmployeeActionFormState(state).isCreating;
export const selectEafEmailSearch = (state: IStore) => selectEmployeeActionFormState(state).searchEaf;
